import { render, staticRenderFns } from "./AsideIcon.vue?vue&type=template&id=1faacd00&"
import script from "./AsideIcon.vue?vue&type=script&lang=js&"
export * from "./AsideIcon.vue?vue&type=script&lang=js&"
import style0 from "./AsideIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports